import { render, staticRenderFns } from "./DinnerItem.vue?vue&type=template&id=2d9a6e5d&scoped=true&"
import script from "./DinnerItem.vue?vue&type=script&lang=js&"
export * from "./DinnerItem.vue?vue&type=script&lang=js&"
import style0 from "./DinnerItem.vue?vue&type=style&index=0&id=2d9a6e5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a6e5d",
  null
  
)

export default component.exports